// App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import AgentHomePage from "./LoPages/lopage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/:loName" element={<AgentHomePage />} />
    </Routes>
  );
}

export default App;